// extracted by mini-css-extract-plugin
var _1 = "sI11DoWeNGyz4T73eGRq";
var _2 = "i8TqhJvq1QoZPKwNzr6_";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "dkYfQpgw_XJf7NpGj2ZG";
var _12 = "eJKdmSWhG8B9yZe9IMjZ";
var _13 = "llFNxJRsiav8h96_Jybm";
var _14 = "hkJTvRj3NgTXG4kJOSQL";
var _15 = "Mx4HoJI_T4AqxBCJj11b";
var _16 = "t7AnCBrMtBlJJiRBVrjA";
var _17 = "ca6iNWClh4uHhjVclm5k";
var _18 = "pwNXPStHvejnoUNiOrQf";
var _19 = "ghM0v1JULmnXzETSh3Rb";
var _1a = "1200px";
var _1b = "992px";
var _1c = "1366px";
var _1d = "768px";
var _1e = "1475px";
var _1f = "576px";
var _20 = "1600px";
var _21 = "320px";
var _22 = "2500px";
var _23 = "iUVN_SAFeTXGc05Z6Wg0";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "dataAccessIcon", _12 as "personalAccessAvatar", _13 as "personalAccessDescription", _14 as "personalAccessDescriptionAccess", _15 as "personalAccessDescriptionName", _16 as "personalAccessOptionRemove", _17 as "personalAccessUser", _18 as "personalAccessUserContent", _19 as "reset-button", _1a as "screenlg", _1b as "screenmd", _1c as "screenml", _1d as "screensm", _1e as "screenxlg", _1f as "screenxs", _20 as "screenxxlg", _21 as "screenxxs", _22 as "screenxxxlg", _23 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "dataAccessIcon": _11, "personalAccessAvatar": _12, "personalAccessDescription": _13, "personalAccessDescriptionAccess": _14, "personalAccessDescriptionName": _15, "personalAccessOptionRemove": _16, "personalAccessUser": _17, "personalAccessUserContent": _18, "reset-button": _19, "screenlg": _1a, "screenmd": _1b, "screenml": _1c, "screensm": _1d, "screenxlg": _1e, "screenxs": _1f, "screenxxlg": _20, "screenxxs": _21, "screenxxxlg": _22, "single-page-responsive-font-size": _23 }
